import { TimerCycles } from '@entities/timer';
import { HistoryEntry } from '@entities/history';

// ---

export default function getNextCycle(
	history: HistoryEntry[],
	longBreakFrequency: number
) {
	debugger;
	const previousCycle = history[history.length - 1]?.cycle;

	if (previousCycle && previousCycle !== TimerCycles.WORK) {
		return TimerCycles.WORK;
	}

	const lastBreaksBeforeLong = history
		.filter((entry) => entry.cycle !== TimerCycles.WORK)
		.slice(-(longBreakFrequency - 1));

	if (
		lastBreaksBeforeLong.length === longBreakFrequency - 1 &&
		lastBreaksBeforeLong.every((entry) => entry.cycle === TimerCycles.BREAK)
	) {
		return TimerCycles.LONG_BREAK;
	}

	return TimerCycles.BREAK;
}
